module.exports = __webpack_public_path__ + "img/bg2.6a52bc51.png";